import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FlexLayoutModule } from '@ngbracket/ngx-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { NgxCurrencyWrapperModule } from './ngx-currency-wrapper.module';
import { NarikCustomValidatorsModule } from '@narik/custom-validators';

import { AccordionAnchorDirective, AccordionDirective, AccordionLinkDirective } from './accordion';
import { AddCostComparisonDialogModule } from './add-cost-comparison-dialog/add-cost-comparison-dialog.module';
import { AddPaymentMethodDialogModule } from './add-payment-method-dialog/add-payment-method-dialog.module';
import { CdkModule } from './cdk/cdk.module';
import { ChickenTestModule } from './chicken-test/chicken-test.module';
import { CreditAccountAlertModule } from './credit-account-alert/credit-account-alert.module';
import {
    DelinquencyRestrictionDialogModule
} from './delinquency-restriction-dialog/delinquency-restriction-dialog.module';
import { DropZoneDirective } from './drop-zone/drop-zone.directive';
import { EditGroupOrTeamDialogModule } from './edit-group-or-team-dialog/edit-group-or-team-dialog.module';
import { AddGroupDialogModule } from './add-group-dialog/add-group-dialog.module';
import { AddTeamDialogModule } from './add-team-dialog/add-team-dialog.module';
import { EditOrganizationDialogModule } from './edit-organization-dialog/edit-organization-dialog.module';
import { EditUserDialogModule } from './edit-user-dialog/edit-user-dialog.module';
import { EmailDuplicateModule } from './email-duplicate/email-duplicate.module';
import { ErrorDialogModule } from './error-dialog/error-dialog.module';
import { FeesComparisonDisplayModule } from './fees-comparison-display/fees-comparison-display.module';
import { FeesSummaryComparisonModule } from './fees-summary-comparison/fees-summary-comparison.module';
import { FileUploadModule } from './file-upload/file-upload.module';
import { ToggleFullscreenDirective } from './fullscreen/toggle-fullscreen.directive';
import { HowToSplitPdfDialogModule } from './how-to-split-pdf-dialog/how-to-split-pdf-dialog.module';
import { InsufficientCreditsDialogModule } from './insufficient-credits-dialog/insufficient-credits-dialog.module';
import { MaterialModule } from './material/material.module';
import { MenuItems } from './menu-items/menu-items';
import { PdfDocumentPreviewModule } from './pdf-document-preview/pdf-document-preview.module';
import { PhonePipe } from './phone-pipe/phone.pipe';
import { SubscriptionAccountAlertModule } from './subscription-account-alert/subscription-account-alert.module';
import { TextSelectModule } from './text-select/text-select.module';
import { TrialAccountAlertModule } from './trial-account-alert/trial-account-alert.module';
import { MomentTimezonePipe } from './tz-pipe/tz.pipe';
import { AppFooterModule as SwipesumFooterModule } from '../../../../../libs/Shared/components/swipesum-footer/swipesum-footer.module';
import { AppHeaderModule as SwipesumHeaderModule } from '../../../../../libs/Shared/components/swipesum-header/swipesum-header.module';
import { StatementTemplateModule } from './statement-template/statement-template.module';
import { StatementLoadingDialogModule } from './statement-loading-dialog/statement-loading-dialog.module';
import { PaidPlanCardModule } from './paid-plan/paid-plan-card.module';

@NgModule({
    imports: [
        SwipesumFooterModule,
        SwipesumHeaderModule,
        StatementTemplateModule,
        CommonModule,
        RouterModule,
        MaterialModule,
        FlexLayoutModule.withConfig({ useColumnBasisZero: false }),
        FormsModule,
        NgxCurrencyWrapperModule,
        ReactiveFormsModule,
        NarikCustomValidatorsModule,
        ErrorDialogModule,
        StatementLoadingDialogModule
    ],
    declarations: [
        AccordionAnchorDirective,
        AccordionLinkDirective,
        AccordionDirective,
        ToggleFullscreenDirective,
        MomentTimezonePipe,
        DropZoneDirective,
        PhonePipe,
    ],
    exports: [
        CommonModule,
        RouterModule,
        MaterialModule,
        CdkModule,
        FormsModule,
        ReactiveFormsModule,
        AccordionAnchorDirective,
        AccordionLinkDirective,
        AccordionDirective,
        ToggleFullscreenDirective,
        EmailDuplicateModule,
        MomentTimezonePipe,
        DropZoneDirective,
        ChickenTestModule,
        FeesComparisonDisplayModule,
        FeesSummaryComparisonModule,
        FileUploadModule,
        CreditAccountAlertModule,
        SubscriptionAccountAlertModule,
        TrialAccountAlertModule,
        EditOrganizationDialogModule,
        EditGroupOrTeamDialogModule,
        AddGroupDialogModule,
        AddTeamDialogModule,
        EditUserDialogModule,
        InsufficientCreditsDialogModule,
        DelinquencyRestrictionDialogModule,
        AddPaymentMethodDialogModule,
        PaidPlanCardModule,
        PhonePipe,
        TextSelectModule,
        HowToSplitPdfDialogModule,
        AddCostComparisonDialogModule,
        PdfDocumentPreviewModule,
        SwipesumFooterModule,
        SwipesumHeaderModule,
        StatementTemplateModule,
        StatementLoadingDialogModule,
    ],
    providers: [MenuItems]
})
export class SharedModule {
    static forRoot(): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: []
        };
    }
}
